var map = {
	"./symbol_0.png": 57532,
	"./symbol_1.png": 9797,
	"./symbol_2.png": 81966,
	"./symbol_3.png": 81463,
	"./symbol_4.png": 59320,
	"./symbol_5.png": 80449,
	"./symbol_6.png": 23018,
	"./symbol_7.png": 54931,
	"./symbol_8.png": 29012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46967;